import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ShareEstimateModal from './ShareEstimateModal';
import estimateSharedSuccessfully from '../../actions/share/estimateSharedSuccessfully';
import shareModal from '../../actions/share/shareModal';
import dismissShareModal from '../../actions/share/dismissShareModal';
import initShareStore from '../../actions/share/initShareStore';

const mapStateToProps = ({ estimateBuilder }) => ({
  selectedCount: estimateBuilder.share.selection.length,
  selectedEstimateId: estimateBuilder.uiState.selectedEstimate,
  shareModalOpen: estimateBuilder.uiState.shareModalOpen || false,
  step: estimateBuilder.uiState.shareStep,
});

const mapDisptachToProps = dispatch => bindActionCreators({
  estimateSharedSuccessfully,
  InitializeShareStore: initShareStore,
  dismissShareModal,
  shareModal,
}, dispatch);

export default connect(mapStateToProps, mapDisptachToProps)(ShareEstimateModal);
